import { Card, Container, TextInput, Toggle, Button } from "@/ui";
import { getTenantInfo } from "@/lib/theme/tenant";

export type AuthPageProps = {
    strapline: string;
    children: React.Node;
};

export default function AuthPage({ strapline, children }: AuthPageProps) {
    const tenantInfo = getTenantInfo();
    const contactLink = `mailto:${tenantInfo.contact}`;

    return (
        <Container className="flex flex-col justify-center items-center h-full gap-12">
            <img
                src={tenantInfo.logo}
                alt={`${tenantInfo.provider} ${tenantInfo.appName} Logo`}
                className="w-[64px] h-[64px]"
            />
            <h1 className="font-semibold text-primary-100 text-3xl">
                {strapline}
            </h1>
            <Card className="max-w-sm w-full flex flex-col">{children}</Card>
            <span className="font-lato">
                Any questions?{" "}
                <a
                    className="text-primary-100 underline hover:text-primary-140 py-1 px-2 ml-0.5 hover:bg-primary-10 rounded transition"
                    href={contactLink}>
                    Contact us
                </a>
            </span>
        </Container>
    );
}
